<!--
 * @Description: 作业监测页面 
 * @Author: chengchongzhen
 * @LastEditors: chengchongzhen
 * @Date: 2022-05-23 10:25:52
 * @LastEditTime: 2022-05-30 18:05:54
-->

<template>
  <div class="work-monitor">
    <!-- 表单 -->
    <div class="form-wrapper">
      <el-form :inline="true" class="form" ref="form">
        <el-form-item label="统计周期:">
          <div style="min-width: 310px">
            <datePicker
              :value="{
                startDate: form.startDate,
                endDate: form.endDate
              }"
              @dateValue="getDate"
            />
          </div>
        </el-form-item>
        <el-form-item label="省市区:">
          <el-cascader
            v-model="cityValue"
            :options="options"
            :props="{ multiple: true }"
            @change="selectArea"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="学校:" prop="schoolId">
          <filterSelect ref="filterSelect" :optionsList="schoolList" @checked="schoolChecked" />
        </el-form-item>
        <el-form-item label="" style="float: right">
          <el-button size="small" @click="resetForm"> 重置 </el-button>
          <el-button type="primary" size="small" @click="getData"> 查询 </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表头说明 + 下载 -->
    <div class="table-head">
      <div class="left">
        作业时间明细
        <el-popover
          placement="bottom-start"
          width="400"
          trigger="hover"
          :visible-arrow="false"
          popper-class="popper-hint"
        >
          <div>
            <h4>作答时间说明：</h4>
            <ul style="list-style: numeric; padding-left: 20px">
              <li>作业采集的时候，要求作答时间书写清晰规范，否则会采集失败，无法识别，显示为"**:**"。</li>
              <li>作业采集的时候，没有填写作业作答时间，显示为空。</li>
              <li>只包含设置建议时长的作业。</li>
            </ul>
          </div>
          <i class="el-icon-info" slot="reference"></i>
        </el-popover>
      </div>
      <div class="right">
        <el-button type="primary" size="small" @click="downExcel" :loading="downLoadStatus"> 导出数据 </el-button>
      </div>
    </div>

    <!-- 表格内容 -->
    <div class="table-wrapper">
      <div class="table-content">
        <el-table
          v-loading="loading"
          height="100%"
          style="width: 100%"
          :data="tableData"
          border=""
          stripe=""
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          size="small"
          @sort-change="sortChange"
        >
          <el-table-column fixed="" label="序号" align="center">
            <template #default="scope">
              <span>{{ (form.pageNum - 1) * form.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="provinceName" label="省" min-width="160px" align="center"> </el-table-column>
          <el-table-column prop="cityName" label="市" min-width="160px" align="center"> </el-table-column>
          <el-table-column prop="localeName" label="区" min-width="160px" align="center"> </el-table-column>
          <el-table-column prop="schoolName" label="学校" min-width="200px" show-overflow-tooltip="" align="center">
          </el-table-column>
          <el-table-column prop="hteName" label="作业名称" min-width="250px" align="center"> </el-table-column>
          <el-table-column prop="htePublishTeaName" label="作业布置教师" min-width="160px" align="center">
          </el-table-column>
          <el-table-column prop="subjectName" label="作业学科" min-width="160px" align="center"> </el-table-column>
          <el-table-column
            prop="suggestedanswertime"
            label="作业建议用时(分钟)"
            sortable="custom"
            min-width="160px"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="studentName" label="学生姓名" min-width="160px" align="center"> </el-table-column>
          <el-table-column prop="gradeNumber" label="年级" min-width="160px" align="center"> </el-table-column>
          <el-table-column prop="executiveclassName" label="班级" min-width="160px" align="center"> </el-table-column>

          <el-table-column prop="submitDate" label="作业提交时间" sortable="custom" min-width="160px" align="center">
          </el-table-column>
          <el-table-column prop="startanswertime" label="开始作答时间" min-width="160px" align="center">
          </el-table-column>
          <el-table-column prop="endanswertime" label="结束作答时间" min-width="160px" align="center">
          </el-table-column>
          <el-table-column
            prop="actualanswertime"
            label="实际用时(分钟)"
            sortable="custom"
            min-width="160px"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="page-wrapper">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="form.pageSize"
          :current-page.sync="form.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { lastWeek } from '@/utils/date.js'
import datePicker from '@/components/datePicker/index.vue'
import filterSelect from '@/components/FilterSelect/index.vue'
import { debounce } from '@/utils/index.js'
import { postHteAnswerTime } from '@/api/modules/work-monitor.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { downLoadHteAnswerTimeDownload } from '@/api/modules/excelApi.js'
// import { saveAs } from 'file-saver'
import fileSave from '@/utils/fileSave.js'

export default {
  name: 'WorkMonitor',
  components: {
    datePicker,
    filterSelect
  },
  data() {
    return {
      form: {
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        schoolIDs: [],
        pageNum: 1,
        pageSize: 12,
        provinceIDs: [],
        cityIDs: [],
        localeIDs: [],
        sortCode: 'submitDate',
        ascOrDes: false,
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      // 省市区
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      options: JSON.parse(sessionStorage.getItem('cityList')),
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      tableData: [],
      loading: false,
      cityValue: [],
      total: 0,
      downLoadStatus: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    /**
     * @description: 获取日期
     * @param {object} date
     * @return {*}
     */
    getDate(date) {
      this.form.startDate = date.startDate
      this.form.endDate = date.endDate
      this.form.pageNum = 1
    },

    /**
     * @description: 选择省市区
     * @param {*} v 选中的值
     * @return {*}
     */
    selectArea: debounce(function (v) {
      this.form.pageNum = 1
      this.address = this.$options.data().address
      this.form.provinceIDs = this.form.cityIDs = this.form.localeIDs = []

      const obj = {
        provinceIDs: [],
        cityIDs: [],
        localeIDs: [],
        provinceIds: [],
        cityIds: [],
        localeIds: []
      }

      for (const el of v) {
        obj.provinceIDs.push(el[0])
        obj.provinceIds.push(el[0])
        obj.cityIDs.push(el[1])
        obj.cityIds.push(el[1])
        obj.localeIDs.push(el[2])
        obj.localeIds.push(el[2])
      }

      for (const key in obj) {
        if (key in this.address) {
          this.address[key] = obj[key]
        }
        if (key in this.form) {
          this.form[key] = obj[key]
        }
      }

      this.getSchools()
    }, 500),

    /**
     * @description:获取学校
     * @return {*}
     */
    getSchools() {
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        this.$refs.filterSelect.checkedValue = ''
        this.form.schoolIDs = []
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    },

    // 获取表格数据
    async getData() {
      try {
        this.loading = true
        const res = await postHteAnswerTime(this.form)
        if (res && res.code === 200) {
          this.tableData = res.result
          if (res.result.length > 0) {
            this.total = res.result[0].total
          } else {
            this.total = 0
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * @description: 表格排序
     * @return {*}
     */
    sortChange({ column, prop, order }) {
      this.form.sortCode = prop
      this.form.pageNum = 1
      if (order !== null) {
        order == 'descending' ? (this.form.ascOrDes = false) : (this.form.ascOrDes = true)
        this.getData()
      }
    },

    /**
     * @description: 选中学校
     * @param {*} list
     * @return {*}
     */
    schoolChecked(list) {
      this.form.pageNum = 1
      this.form.schoolIDs = list.map((item) => item.value)
    },

    /**
     * @description: 导出表格
     * @return {*}
     */
    downExcel() {
      this.downLoadStatus = true
      let obj = {
        fileName: '',
        ...this.form,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      obj.fileName = excelName('学生提交作业数据统计', obj.startDate, obj.endDate)

      fileSave(downLoadHteAnswerTimeDownload + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
        this.downLoadStatus = false
      })
    },

    /**
     * @description: 表格分页
     * @return {*}
     */
    handleCurrentChange() {
      this.getData()
    },

    /**
     * @description: 重置表单
     * @return {*}
     */
    resetForm() {
      this.form = this.$options.data().form
      this.address = this.$options.data().address
      this.cityValue = this.$options.data().cityValue
      this.$refs.filterSelect.checkedValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #fff;

.work-monitor {
  display: flex;
  flex-direction: column;
  height: calc(100% - 44px);
}

.form-wrapper {
  @include myHeader();
  display: flex;
  align-items: center;
  .form {
    width: 100%;
  }
  & .el-form-item {
    margin-bottom: 0;
    &:last-child {
      margin-right: 0;
    }
  }
}

.table-head {
  @include myContent-hint();
  background: $bg;
  margin-top: 16px;
}

.table-wrapper {
  flex: 1;
  background: $bg;
  overflow: auto;
  padding: 16px 20px 0;
}

.table-content {
  height: calc(100% - 52px);
}

.page-wrapper {
  text-align: right;
  margin: 10px 0;
}
</style>
